// import React, { useState, useEffect } from 'react';
import '../css/homecontentin.css'
import TheBar from './the-bar'
import OddDaysRandom from './odd-days-random'

function HomeContent({ currentMonth, currentYear }) {
  
  // console.log("CURRENT INSIDE HomeContent", currentMonth, currentYear)

  return (
    <>
      <div id="main-header">

        <OddDaysRandom currentMonth={currentMonth} currentYear={currentYear} />

        <TheBar currentYear={currentYear} currentMonth={currentMonth} />

      </div>
    </>
  )
}

export default HomeContent;
